<!-- 翻译 -->
<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { languages } from '@/i18n'

const { locale } = useI18n()

const currentLocale = computed(() => locale.value)

const handleSelect = (value) => {
    if (value !== currentLocale.value) {
        locale.value = value
        localStorage.setItem('arco-locale', value)
        // 重载页面以应用语言切换
        window.location.reload()
    }
}

</script>

<template>
    <a-dropdown @select="handleSelect" position="br">
        <a-button type="text" class="locale-switch hy-site-button">
            <template #icon>
                <!-- 自定义 SVG 地球图标 -->
                <svg class="hy-site-button__globe" viewBox="0 0 20 20" fill="none"
                        xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                        <circle cx="10" cy="10" r="7.4" stroke="currentColor" stroke-width="1.45" />

                        <path d="M2.9 10H17.1" stroke="currentColor" stroke-width="1.35" stroke-linecap="round" />

                        <path d="M10 2.65C12.1 4.65 13.25 7.2 13.25 10C13.25 12.8 12.1 15.35 10 17.35"
                            stroke="currentColor" stroke-width="1.35" stroke-linecap="round" />

                        <path d="M10 2.65C7.9 4.65 6.75 7.2 6.75 10C6.75 12.8 7.9 15.35 10 17.35" stroke="currentColor"
                            stroke-width="1.35" stroke-linecap="round" />
                    </svg>
            </template>
            <span class="pc">{{ $t('common.language') }}</span>
            <icon-down class="pc" />
        </a-button>
        <template #content>
            <a-doption v-for="lang in languages" :key="lang.value" :value="lang.value"
                :selected="lang.value === currentLocale">
                {{ lang.label }}
            </a-doption>
        </template>
    </a-dropdown>
</template>

<style scoped lang="less">
.arco-btn-size-medium:not(.arco-btn-only-icon) .arco-btn-icon {
    margin-right: 5px;
}
/* 站点按钮 */
.hy-site-button {
    display: inline-flex;
    align-items: center;

    min-width: max-content;
    height: 34px;

    color: #202a3a;
    background: transparent;
    border: 0;

    font-family: '思源黑';
    font-size: 13px;
    font-weight: 500;
    line-height: 34px;

    cursor: pointer;
    outline: none;
    white-space: nowrap;
}

.hy-site-button__globe {
    width: 15px;
    height: 15px;
}

.hy-site-button__arrow {
    width: 9px;
    height: 9px;
    margin-left: -1px;

    color: #5f6878;
}
</style>